(function () {
  'use strict';

  angular
    .module('adminCommanderDiscretion')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('adminCommanderDiscretion', {
          sticky: true,
          url: '/adminCommanderDiscretion',
          views: {
              'adminCommanderDiscretionView': {
                  templateUrl: 'commander-discretion/views/admin-crew-batchers.tpl.html',
                  controller: 'AdminCommanderDiscretionCtrl',
                  controllerAs: 'adminCommanderDiscretion'
              }
          }
      });
  }
}());
